import PropTypes from 'prop-types';
import React from 'react';
import { useInView } from 'react-intersection-observer';
import { heading } from 'components/Home/classes'
import {Heading} from 'components/Heading';
import LottieAnimation from 'components/LottieAnimation';

export const FeatureItem = ({ animationData, title, description, comingSoon }) => {
  const [animationWrapperRef, isAnimationWrapperInView] = useInView({
    triggerOnce: true,
    threshold: 0.6,
  });

  const lottieData = {
    lottieOptions: {
      animationData,
    },
    isInView: isAnimationWrapperInView,
  };

  return (
    <li className="sm:max-w-[410px]" ref={animationWrapperRef}>
      <LottieAnimation className="absolute top-0 left-0 h-full w-full" {...lottieData} />
      <div className="mt-5">
        <h3 className={heading('title', 'primary', 'my-2')}>
                {title}
            </h3>
        <p className="mt-3 max-w-[377px] font-book leading-snug text-primary lg:mt-2 lg:max-w-none">
          {description}
        </p>
        {comingSoon && (
          <span className="mt-2 block whitespace-nowrap text-sm font-normal leading-none text-orange">
            Coming soon...
          </span>
        )}
      </div>
    </li>
  );
};

FeatureItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  comingSoon: PropTypes.bool,
};

FeatureItem.defaultProps = {
  comingSoon: false,
};

export default FeatureItem;
